import Component from '../colorz/Component';

export default class TextExpand extends Component {
	onInit(el) {
		this.el = el;
		this.container = this.el.querySelector('[data-expand-container]');
		this.entireText = this.el.querySelector('[data-expand-entire-text]');
		this.excerpt = this.el.querySelector('[data-expand-excerpt]');
		this.readMoreButton = this.el.querySelector('[data-expand-more]');
		this.readLessButton = this.el.querySelector('[data-expand-less]');

		if (this.readMoreButton && this.readLessButton) {
			this.readMoreButton.addEventListener('click', () => {
				this.readMore();
				this.readLessButton.classList.remove('!u-hidden');
				this.readMoreButton.classList.add('!u-hidden');
				this.excerpt.classList.add('u-hidden');

				// focus sur le texte complet
				this.entireText.setAttribute('tabindex', '-1');
				this.entireText.focus();
			});
			this.readLessButton.addEventListener('click', () => {
				this.readLess();
				this.readMoreButton.classList.remove('!u-hidden');
				this.readLessButton.classList.add('!u-hidden');
				this.excerpt.classList.remove('u-hidden');

				// focus sur le bouton "read more"
				this.entireText.removeAttribute('tabindex');
				this.readMoreButton.focus();
			});
		}
	}

	readMore() {
		this.entireText.classList.remove('u-hidden');
	}

	readLess() {
		this.entireText.classList.add('u-hidden');
	}
}
